export default class Configuration {
    static set(data) {
        this.configuration = data;
    }
    static get(key){
        return key === null ? this.configuration : this.configuration[key];
    }
}
